/* eslint-disable */
import { ENTRY_PORTAL_CUSTOMER_COMPANY, ENTRY_PORTAL_CUSTOMER_NAME } from '../../../Entries/PortalCustomer/PortalCustomer.entry.constants';

/**
 * The wrapper to add meta data to the analytics data
 * @param {any} services The services
 * @returns {any} The event map
 */
const withMetaData = (services) => () => ({
  entry: {
    company: ENTRY_PORTAL_CUSTOMER_COMPANY,
    name: ENTRY_PORTAL_CUSTOMER_NAME,
  },
  user: {
    id: services.authService.getUserId(),
  },
});

export default withMetaData;
